<template>
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
  >
    <v-card
      dark
    >
      <v-card-text>
        Daten werden geladen..
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Formcomponents/Loader.vue